class AnimateBar extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-30px',
      threshold: 0,
    })

    this.observer.observe(this)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.setAttribute('animate', '')

    observer.unobserve(this)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }
}

if (!customElements.get('animate-bar')) {
  customElements.define('animate-bar', AnimateBar)
}
